import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { selectMessageBrokerMultiaddr } from '@/store/selectors/organization';
import type { P2PDiagnostics } from '@/types/P2PDiagnostics';

/**
 * Pulls the read-only P2P diagnostics snapshot from the stack manager. The broker
 * multiaddr lives in the organization slice (services cannot read Redux), so the thunk
 * reads it here and passes it in for broker-status derivation.
 */
export const refreshP2PDiagnosticsThunk = createAppAsyncThunk<P2PDiagnostics>(
  'debug/refreshP2PDiagnostics',
  async(_, { getState, extra: { pocServices } }) => {
    const brokerMultiaddr = selectMessageBrokerMultiaddr(getState());
    return await pocServices.p2pStackManagerService.getDiagnosticsSnapshot(brokerMultiaddr);
  }
);
